import React from 'react';
import { FadeIn } from './ui/FadeIn';

export function WhoFor() {
  return (
    <section className="py-section-mob md:py-section-desk bg-paper">
      <div className="max-w-content mx-auto px-pad-mob md:px-pad-desk">
        <FadeIn>
          <h2 className="font-heading text-h2-mob md:text-h2-desk text-ink mb-12 md:mb-20">
            Who this is for
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-0 relative">
          {/* Desktop Divider */}
          <div className="hidden md:block absolute top-0 bottom-0 left-1/2 w-[1px] bg-hairline -translate-x-1/2"></div>
          
          {/* Left Column */}
          <FadeIn className="md:pr-16">
            <h3 className="font-heading text-[24px] text-ink mb-8">This is for you if…</h3>
            <ul className="space-y-5">
              {[
                "You run a B2B company between 2 and 50 people.",
                "You sell to other businesses in marketing, IT, software, consulting, or staffing.",
                "You've tried lead-gen agencies and come away suspicious of them.",
                "You'd rather pay once for strategy than monthly for someone pulling random lists.",
                "You can tell the difference between a well-written email and a bad one."
              ].map((item, i) => (
                <li key={i} className="flex flex-col items-start font-body text-body-base text-ink relative pl-6">
                  <span className="absolute left-0 top-[10px] w-2 h-2 bg-ink rounded-sm"></span>
                  {item}
                </li>
              ))}
            </ul>
          </FadeIn>

          {/* Right Column */}
          <FadeIn delay={0.1} className="md:pl-16">
            <h3 className="font-heading text-[24px] text-graphite mb-8">This is not for you if…</h3>
            <ul className="space-y-5">
              {[
                "You need someone to run campaigns end-to-end for you. I consult, I don't operate.",
                "You're looking for the cheapest option. I'm not.",
                "You sell B2C, high-volume ecommerce, or crypto.",
                "You want guaranteed numbers in week one. Good outbound takes 4–8 weeks to calibrate.",
                "You've never spoken to a customer and don't plan to start."
              ].map((item, i) => (
                <li key={i} className="flex flex-col items-start font-body text-body-base text-graphite relative pl-6">
                  <span className="absolute left-0 top-[10px] w-2 h-2 bg-graphite rounded-sm"></span>
                  {item}
                </li>
              ))}
            </ul>
          </FadeIn>

        </div>
      </div>
    </section>
  );
}